import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Radium from 'radium'
import { translate } from 'react-i18next'
import moment from 'moment'

import { isVideoAsset, isImageAsset } from 'util/file'
import { formatTime } from 'util/string'


/* Components */
import PlaylistAsset from './asset'

/* Widgets */
import TextInput from 'widget/text-input'
import TagInput from 'widget/tag-input'
import DatetimeInput from 'widget/datetime-input'
import DropdownButton from 'widget/dropdown-button'
import { Highlight, MODE as HIGHLIGHT_MODE } from 'widget/highlight'
import { RemoveDialog, SCHEME as REMOVE_DIALOG_SCHEME } from 'widget/remove-dialog'
import InfoText from 'widget/info-text'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'
import {
    saveName,
    saveTags,
    saveStartTime,
    saveStopTime,
    appendAsset,
    deleteSingleItem,
    removeAndAppendAsset,
    duplicate,
    expand,
    collapse,
    fetchExpanded
} from 'react-redux/actions/playlist'
import { startDrag, stopDrag } from 'react-redux/actions/drag-and-drop'
import { select } from 'react-redux/actions/highlight'

/* Selectors */
import { getItem } from 'react-redux/selectors/playlist'
import { getDragAndDrop } from 'react-redux/selectors/drag-and-drop'

/* Styles */
import './item.css'

/* Single Playlist List Item */
class PlaylistItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isDropTarget: false,
            removeCommit: false,
            dragging: false
        }
        this.dragEnterCount = 0
    }

    componentDidMount() {
        const { fetchExpanded, uid } = this.props
        if(!uid) return
        fetchExpanded(uid)
    }

    componentWillReceiveProps(nextProps) {
        const { fetchExpanded,  uid } = this.props
        if(!nextProps.uid || nextProps.uid === uid) return
        fetchExpanded(nextProps.uid)
    }

    toggleCollapse(e) {
        const { uid, expanded, expand, collapse } = this.props
        e.stopPropagation()
        if (!expanded) expand(uid)
        else collapse(uid)
    }

    onSaveName(value) {
        const { uid, saveName } = this.props
        saveName(uid, value)
    }

    onEditName() {
        const { select, uid } = this.props
        select("playlist", uid)
    }

    validateName(value) {
        return value && value.length
    }

    onSaveTags(tags) {
        const { uid, saveTags } = this.props
        saveTags(uid, tags)
    }

    onEditTags() {
        const { select, uid } = this.props
        select("playlist", uid)
    }

    onRemoveClick(e) {
        const { uid } = this.props
        e.stopPropagation()
        this.setState({
            removeCommit: true
        })
    }

    onBlur(e) {
        this.setState({
            removeCommit: false
        })
    }

    onRemoveCommitMouseDown(e) {
        e.preventDefault()
        e.stopPropagation()
    }

    onRemoveCommitBackgroundClick(e) {
        e.preventDefault()
        e.stopPropagation()
    }

    onRemoveCommitClick(e) {
        const { deleteSingleItem, uid } = this.props
        e.stopPropagation()
        deleteSingleItem(uid)
    }

    onRemoveCancelClick(e) {
        e.stopPropagation()
        this.setState({
            removeCommit: false
        })
    }

    onDuplicateClick(e) {
        const { uid, duplicate } = this.props
        duplicate(uid)
    }

    onSaveStartTime(value) {
        const { uid, saveStartTime } = this.props
        if (value && this.validateStartTime(value)) {
            saveStartTime(
                uid,
                moment(value).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            )
        } else if (!value) {
            saveStartTime(uid, null)
        }
    }

    onEditStartTime() {
        const { select, uid } = this.props
        select("playlist", uid)
    }

    validateStartTime(value) {
        if (this.props && this.props.timeConstraint) {
            const { timeConstraint } = this.props
            const { stopTime } = timeConstraint
            if (value && stopTime) {
                if (moment(stopTime).isBefore(value)) return false
            }
        }
        return true
    }


    onSaveStopTime(value) {
        const { uid, saveStopTime } = this.props
        if (value && this.validateStopTime(value)) {
            saveStopTime(
                uid,
                moment(value).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            )
        } else if (!value) {
            saveStopTime(uid, null)
        }
    }

    onEditStopTime() {
        const { select, uid } = this.props
        select("playlist", uid)
    }

    validateStopTime(value) {
        if (this.props && this.props.timeConstraint) {
            const { timeConstraint } = this.props
            const { startTime } = timeConstraint
            if (startTime && value) {
                if (moment(value).isBefore(startTime)) return false
            }
        }
        return true
    }


    isSelected() {
        const { domain, uid } = this.props.highlight.active
        return domain === "playlist" && uid === this.props.uid
    }

    isAscendant() {
        const { ascendants } = this.props.highlight
        return ascendants["playlist"] && ascendants["playlist"][this.props.uid]

    }

    isDescendant() {
        const { descendants } = this.props.highlight
        return descendants["playlist"] && descendants["playlist"][this.props.uid]
    }


    getListItemClass() {
        const { expanded } = this.props
        const { isDropTarget } = this.state
        var className = "playlist-item component"
        if (this.isSelected()) className += " highlight-selected"
        else if (this.isAscendant()) className += " highlight-ascendant"
        else if (this.isDescendant()) className += " highlight-descendant"
        if (isDropTarget) className += " drop-target"
        if (!expanded) className += " collapsed"
        return className
    }

    /* Drag & Drop */
    onDragStart(e) {
      const {
          uid,
          startDrag
      } = this.props
      this.nameInput.inputElement.blur()
      if(this.startInput && this.startInput.inputElement) this.startInput.inputElement.blur()
      if(this.stopInput && this.stopInput.inputElement) this.stopInput.inputElement.blur()
      this.setState({ dragging: true })
      e.stopPropagation()
      e.dataTransfer.setData('text', JSON.stringify({ uid, domain:'playlist' }))
      startDrag('playlist', uid )
    }

    onDragEnd(e) {
        this.setState({ dragging: false })
        e.stopPropagation()
    }

    onDragEnter(e) {
        const { domain } = this.props.dragAndDrop
        this.dragEnterCount++
        e.preventDefault()
        e.stopPropagation()
        if (this.state.isDropTarget) return
        if (domain === "asset" || domain === "playlistAsset") {
            this.setState({isDropTarget: true})
        } else {
            this.setState({isDropTarget: false})
        }
    }

    onDragOver(e) {
        e.preventDefault()
        e.stopPropagation()
    }

    onDragLeave(e) {
        e.preventDefault()
        e.stopPropagation()
        if(this.dragEnterCount) this.dragEnterCount--
        if (!this.dragEnterCount) this.setState({isDropTarget: false})
    }

    onDrop(e) {
        const { uid, appendAsset, removeAndAppendAsset } = this.props
        e.preventDefault()
        e.stopPropagation()
        try {
          const data = JSON.parse(e.dataTransfer.getData('text'))
          if (data.domain === "asset") {
              appendAsset(uid, data.uid)
          } else if (data.domain === "playlistAsset") {
              removeAndAppendAsset(data.uid, data.index, uid)
          }
        } catch (e) {
          return
        }
        this.dragEnterCount = 0
        this.setState({ isDropTarget: false })
    }

    /* Helpers */
    isCollapsed() {
        const { expanded } = this.props
        return !expanded
    }

    measureHeight() {
        if(!this.playlistElement) return null
        const bounds = this.playlistElement.getBoundingClientRect()
        return bounds.height
    }

    calcPlaylistDuration() {
        const { mediaObjects, assets } = this.props
        let dur = 0
        let inf = false
        if (mediaObjects && mediaObjects.length) {
            _.each(mediaObjects, (mediaObject) => {
                  if (mediaObject.duration) {
                      dur += mediaObject.duration
                  } else {
                     const asset = assets[mediaObject.assetId]
                     if (asset && asset.fileName && isVideoAsset(asset.fileName)) {
                        dur += asset.duration
                     } else if (asset && asset.fileName && isImageAsset(asset.fileName)){
                        inf = true
                     }
                  }
            })
        }
        return inf?-1:dur
    }

    /* Rendering */

    renderRemoveCommit() {
        const { t, name, uid } = this.props
        const { removeCommit } = this.state
        if (!removeCommit) return null
        return (
          <RemoveDialog
            text={ t('playlist:item.removeDialog.text', {name: name || uid}) }
            height={ this.measureHeight() }
            scheme={ REMOVE_DIALOG_SCHEME.REMOVE }
            onCancel={ this.onRemoveCancelClick.bind(this) }
            cancelLabel={ t("playlist:item.removeDialog.cancelButtonLabel") }
            onConfirm={ this.onRemoveCommitClick.bind(this) }
            confirmLabel={ t("playlist:item.removeDialog.confirmButtonLabel") }
            />
        )
    }

    renderToggleCollapseButton() {
        const { t, uid, mediaObjects } = this.props
        if (!mediaObjects || !mediaObjects.length) return null
        if (this.isCollapsed()) return (
            <button
                value={ uid }
                className="icon"
                title={ t("playlist:item.expand") }
                onClick={ this.toggleCollapse.bind(this) }>
                <Icon icon={ ICON.CARET_DOWN } size={ 24 } circle={ false } />
            </button>
        )
        return (
            <button
                value={ uid }
                className="icon"
                title={ t("playlist:item.collapse") }
                onClick={ this.toggleCollapse.bind(this) }>
                <Icon icon={ ICON.CARET_UP } size={ 24 } circle={ false } />
            </button>
        )
    }


    getToolbarItems() {
        const { t, usageCount }  = this.props
        let items = [
            {
              name: t("playlist:item.menu.duplicateLabel"),
              title: t("playlist:item.menu.duplicateTitle"),
              icon: ICON.DUPLICATE,
              onClick: this.onDuplicateClick.bind(this)
            }
        ]
        if(usageCount>0) {
          items.push({
              name: t("playlist:item.menu.noRemoveLabel"),
              title: t("playlist:item.menu.noRemoveTitle"),
              icon: ICON.PROHIBITED,
              iconScheme: ICON_SCHEME.WARNING
          })
        } else {
          items.push({
              name: t("playlist:item.menu.removeLabel"),
              title: t("playlist:item.menu.removeTitle"),
              icon: ICON.DELETE,
              iconScheme: ICON_SCHEME.DANGER,
              onClick: this.onRemoveClick.bind(this)
          })
        }
        return items
    }

    renderItemToolbar() {
        const { t } = this.props
        return (
            <div className="toolbar">
                <DropdownButton
                  title={ t('playlist:item.menuTitle') }
                  menu={ { items:this.getToolbarItems() } }/>
                { this.renderToggleCollapseButton() }
            </div>
        )
    }

    renderAssets() {
        const { mediaObjects, uid } = this.props
        return (
            _.map(mediaObjects, (mediaObject, index) => {
                return (
                    <PlaylistAsset
                        key={ index }
                        uid={ uid }
                        index={ index }
                    />
                )
            })
        )
    }

    renderAssetSection() {
        if (this.isCollapsed()) return null
        return (
            <div className="asset">
                <ul
                    className="asset-list"
                >
                    { this.renderAssets() }
                </ul>
            </div>
        )
    }

    renderStartInput() {
        if (this.isCollapsed()) return null
        const { t, timeConstraint } = this.props
        let value = null
        if(timeConstraint && timeConstraint.startTime){
          value =  moment(timeConstraint.startTime).local().toDate()
        }
        return (
          <DatetimeInput
            label={ t('playlist:item.startInput.label') }
            labelWidth={ 50 }
            placeholder={ t('playlist:item.startInput.placeholder') }
            value={ value }
            ref={ (elem) => { this.startInput = elem }}
            onSave={ this.onSaveStartTime.bind(this) }
            onEdit={ this.onEditStartTime.bind(this) }
            validate={ this.validateStartTime.bind(this) }
            clearTitle={ t("input:clearTitle")}
            resetTitle={ t("input:resetTitle")}
            saveTitle={ t("input:saveTitle")}
          />
        )

    }

    renderStopInput() {
        if (this.isCollapsed()) return null
        const { t, timeConstraint } = this.props
        let value = null
        if(timeConstraint && timeConstraint.stopTime){
          value =  moment(timeConstraint.stopTime).local().toDate()
        }
        return (
          <DatetimeInput
            label={ t('playlist:item.stopInput.label') }
            labelWidth={ 50 }
            placeholder={ t('playlist:item.stopInput.placeholder') }
            value={ value }
            ref={ (elem) => { this.stopInput = elem }}
            onSave={ this.onSaveStopTime.bind(this) }
            onEdit={ this.onEditStopTime.bind(this) }
            validate={ this.validateStopTime.bind(this) }
            clearTitle={ t("input:clearTitle")}
            resetTitle={ t("input:resetTitle")}
            saveTitle={ t("input:saveTitle")}
          />
        )

    }

    getHighlightMode() {
      if (this.isSelected()) return  HIGHLIGHT_MODE.SELECTED
      else if (this.isAscendant()) return  HIGHLIGHT_MODE.CHILD
      else if (this.isDescendant()) return  HIGHLIGHT_MODE.PARENT
    }

    render() {
        const {
            t,
            uid,
            name,
            tags,
            mediaObjectCount,
            select,
            pending
        } = this.props
        if (pending) {
          return (
            <li
              className={ this.getListItemClass() }
              key={ uid }
              data-uid={ uid }
            >
              loading
            </li>
          )
        }
        const dur = this.calcPlaylistDuration()
        const durStr = (dur == -1)?"∞":formatTime(dur/1000)
        return (
            <li
                className={ this.getListItemClass() }
                key={ uid }
                data-uid={ uid }
            >
                <div
                  className="playlist"
                  ref={ (elem) => { this.playlistElement = elem } }
                  onClick={ (e) => { select("playlist", uid) } }
                  onDragStart={ this.onDragStart.bind(this) }
                  onDragEnter={ this.onDragEnter.bind(this) }
                  onDragOver={ this.onDragOver.bind(this) }
                  onDragLeave={ this.onDragLeave.bind(this) }
                  onDrop={ this.onDrop.bind(this) }
                  onDragEnd={ this.onDragEnd.bind(this) }
                  draggable="true"
                >
                    <div className="border">
                        <div className="detail">
                            <Highlight mode={ this.getHighlightMode() } />
                            <div className="label">
                                <TextInput
                                    className="name"
                                    value={ name }
                                    ref={ (elem) => { this.nameInput = elem }}
                                    placeholder={ t('playlist:item.nameInput.placeholder') }
                                    onSave={ this.onSaveName.bind(this) }
                                    onEdit={ this.onEditName.bind(this) }
                                    validate={ this.validateName.bind(this) }
                                    clearTitle={ t("input:clearTitle")}
                                    resetTitle={ t("input:resetTitle")}
                                    saveTitle={ t("input:saveTitle")}
                                />
                                <div className="info-wrapper">
                                  <InfoText text={ t("playlist:item.assetCount", {value: mediaObjectCount.toString()}) }/>
                                  <InfoText text={ t("playlist:item.duration", {value: durStr}) }/>
                                </div>
                                <div className="time-constraint">
                                    { this.renderStartInput() }
                                    { this.renderStopInput() }
                                </div>
                                <TagInput
                                  value={ tags || [] }
                                  placeholder={ t('playlist:item.tagInput.placeholder') }
                                  onSave={ this.onSaveTags.bind(this) }
                                  onEdit={ this.onEditTags.bind(this) }
                                  clearTitle={ t("input:clearTitle")}
                                  resetTitle={ t("input:resetTitle")}
                                  saveTitle={ t("input:saveTitle")}
                                ></TagInput>
                            </div>
                            { this.renderItemToolbar() }
                        </div>
                    </div>
                </div>
                { this.renderAssetSection() }
                { this.renderRemoveCommit() }
            </li>
        )
    }
}

PlaylistItem.propTypes = {
    uid: PropTypes.string.isRequired,
}

function mapStateToProps(state){
    return state
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            showModal,
            hideModal,
            appendAsset,
            expand,
            collapse,
            fetchExpanded,
            saveName,
            saveTags,
            saveStartTime,
            saveStopTime,
            deleteSingleItem,
            startDrag,
            stopDrag,
            removeAndAppendAsset,
            duplicate,
            select
        },
        dispatch
    )
}

function mergeProps(stateProps, dispatchProps, ownProps){
    return Object.assign(
        {},
        dispatchProps,
        getItem(stateProps, ownProps.uid),
        { dragAndDrop: getDragAndDrop(stateProps) },
        { highlight: stateProps.highlight },
        { assets: stateProps.asset.list.items },
        ownProps
    )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PlaylistItem)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default Radium(translatedComponent)



// WEBPACK FOOTER //
// ./src/app/component/playlist/item.jsx